import React from 'react';
import { Link } from 'react-router-dom';
import Banner from './Dashboard/Banner';
import Featureblog from './Dashboard/Featureblog';
// import HeaderNav from './Dashboard/HeaderNav';
// import MembershipPlans from './Dashboard/MembershipPlans';
// import Testimonials from './Dashboard/Testimonials';
import Jobsection from '../Jobs/Jobsection';
import bnr2 from '../../../images/background/bg4.jpg';

function Dashboard() {

    return (
        <>
            {/* <HeaderNav /> */}
            <Banner />
            <Featureblog />
            <Jobsection />
            {/* <Testimonials /> */}
            {/* <MembershipPlans /> */}
            <div className="section-full content-inner-2 call-to-action overlay-black-dark text-white text-center bg-img-fix" style={{ backgroundImage: "url(" + bnr2 + ")" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 className="m-b10">Make a Difference with Your Online Resume!</h2>
                            <p className="m-b0">Lorem Ipsum is simply dummy text of the printing and typesetting industry...</p>
                            <Link to={"/register"} className="site-button m-t20 outline outline-2 radius-xl">Create an Account</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;